<template>
  <div class="plus-btn d-flex justify-center" @click="onClick">
    <v-img src='@/assets/SVG/add-gris.svg' style="max-width:22px;">
    </v-img>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    onClick(): void {
      this.$emit("callback");
    }
  }
})

</script>
